'use strict';
import angular from 'angular';
import ngFileUpload from 'ng-file-upload';
import SignupController from './signup.controller';
import SignupService from './signup.service';
import UserService from '../../../components/auth/user.service';
import GeneralInfoForm from '../../../components/forms/account/general-info';
import ProfessionalInfoForm from '../../../components/forms/account/professional-info';
import CredentialForm from '../../../components/forms/account/credential';
import CreditCardForm from '../../../components/forms/account/credit-card';
import { SignupEvents } from './signup-events';
// import ShippingAddressForm from '../../../components/forms/account/shipping-address';
export default angular.module('eeComUiApp.signup', [GeneralInfoForm, ProfessionalInfoForm, CredentialForm,
    CreditCardForm, ngFileUpload
])
    .service('SignupService', SignupService)
    .service('UserService', UserService)
    .service('SignupEvents', SignupEvents)
    .component('signup', {
    template: require('./signup.html'),
    controller: SignupController
})
    .name;
//# sourceMappingURL=index.js.map